<template>
  <v-overlay :value="getLoadingOverlay" style="z-index: 999;">
    <v-row
      v-if="auth === true"
      no-gutters
      align="center"
      justify="center"
      class="mb-2"
    >
      <span>Authentification</span>
    </v-row>
    <v-row no-gutters align="center" justify="center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-row>
    <v-btn
      fixed
      color="rgba(0,0,0,0)"
      fab
      top
      right
      text
      @click="$store.dispatch('endLoadingOverlay')"
    >
      <v-icon></v-icon>
    </v-btn>
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProgressOverlay",
  props: {
    auth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getLoadingOverlay"])
  }
};
</script>

<style lang="scss" scoped></style>
